export default (id, coll) => coll.find((x) => x.id === id)
